import React from 'react';

import _ from '@ihme/common/locale';
import styled from '@ihme/common/theme/styled';

import PageHeader from '../../components/PageHeader';
import ChartHighlight from '../../components/ChartHighlight';
import BreakdownChartSection from './BreakdownChartSection';

const PageContainer = styled.div(({ theme }) => ({
    paddingBottom: 50,
}));

const Footnote = styled.div(({ theme }) => ({
    fontSize: 12,
}));

class BreakdownScene extends React.Component {
    render() {
        return (
            <PageContainer>
                <PageHeader>{_('breakdown_scene_title')}</PageHeader>
                <ChartHighlight>{_('breakdown_scene_description')}</ChartHighlight>
                <BreakdownChartSection />
                <Footnote>{_('breakdown_scene_footnote')}</Footnote>
            </PageContainer>
        );
    }
}

export default BreakdownScene;
